module.exports = __webpack_public_path__ + "img/modal.870b8882.png";